import numeral from 'numeral';

export const INCLUDES_TAX_TEXT = 'tax inclusive';
export const EXCLUDES_TAX_TEXT = 'tax exclusive';
export const PLUS_TAX_TEXT = '+ tax';

// takes in an integer number of cents (12345)
// and converts it to a human-readable string ("$123.45")
export function formatCents(cents: number): string {
  return numeral(cents).divide(100).format('$0,0.00');
}

/**
 * Generate tax inclusion text for display
 */
export function getTaxInclusionText(includesTax: boolean): string {
  return includesTax ? INCLUDES_TAX_TEXT : EXCLUDES_TAX_TEXT;
}

/**
 * Generate nightly rate label without tax inclusion information
 * Tax context is now shown separately as small grey text
 */
export function getNightlyRateLabel(): string {
  return 'Nightly rate:';
}

/**
 * Extract pricing information, preferring THS price over avgPrice
 */
export function getPricingInfo(booking: {
  thsPrice?: { nightlyPrice: number; includesTax: boolean } | null;
  avgPrice: number;
}) {
  // Use THS price if available, otherwise fall back to avgPrice
  const nightlyRateAmount = booking.thsPrice?.nightlyPrice ?? booking.avgPrice;
  const nightlyRate = formatCents(nightlyRateAmount);
  const includesTax = booking.thsPrice?.includesTax;

  // Generate appropriate label based on tax inclusion
  const nightlyRateLabel = getNightlyRateLabel();

  return {
    nightlyRateAmount,
    nightlyRate,
    includesTax,
    nightlyRateLabel,
  };
}
